// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";  // <-- Import getStorage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBOHP9eHdNKX-1sQOdM-0IAxn8wTggpYS8",
  authDomain: "portfolioblog-f6d58.firebaseapp.com",
  projectId: "portfolioblog-f6d58",
  storageBucket: "portfolioblog-f6d58.firebasestorage.app",
  messagingSenderId: "298303732063",
  appId: "1:298303732063:web:f11e89e6c2328ef47adeea",
  measurementId: "G-91N31SK7F1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);  // <-- Export storage
const analytics = getAnalytics(app);
